<template>

  <div class="border-layout">
    <div v-if="heading">
      <h2>&nbsp;{{heading}}</h2>
    </div>
    <DataTable :value="items" ref="table"
        :loading="this.loading" :rowHover="true" v-model:selection="selected"
        @row-select="onSelect"
        :rows="10"
        dataKey="id" selectionMode="single" :scrollable="true" scrollHeight="flex"
        class="p-datatable-gridlines p-datatable-striped p-datatable-sm center">
      <slot name="table"></slot>
      <template #header>
        <div class="p-d-flex p-jc-between">
          <div>
            <span class="p-input-icon-left">
              <i class="pi pi-search" />
              <InputText placeholder="Търсене" style="width: 20em" v-model="searchQuery" v-on:keyup="refresh"/>
            </span>
          </div>
          <div>
            <slot name="filter"></slot>
          </div>
          <div>
            <slot name="buttons-left"></slot>
          </div>
          <span class=p-buttonset>
            <Button
                label="Добави"
                icon="pi pi-plus"
                class="p-button-success"
                @click="onCreate"
            />
            <Button
                label="Редактирай"
                icon="pi pi-pencil"
                class="p-button-primary"
                @click="onEdit"
                :disabled="!selected"
            />
            <Button
                label="Изтрий"
                icon="pi pi-trash"
                class="p-button-danger"
                @click="operation.delete = true"
                :disabled="!selected"
            />
            <slot name="buttons-right"></slot>
          </span>
        </div>
      </template>
      <template #empty> Няма налични данни </template>
      <template #loading> Моля изчакайте... </template>
    </DataTable>
  </div>

  <!-- // https://github.com/primefaces/primevue/issues/198 maxHeight: '90wh'  :style="{ width: '900px' }" -->
  <Dialog v-model:visible="editingOrCreating" :modal="true" position="center" :contentStyle="{'overflow': 'visible'}" :closeOnEscape="false">
    <template #header>
      <h2 v-if="operation.create">{{headingCreate}}</h2>
      <h2 v-if="operation.modify">{{headingModify}}</h2>
    </template>
    <div v-if="operation.loading" class="p-text-center">
      <ProgressSpinner/>
    </div>
    <div v-if="!operation.loading">
      <slot name="form" :entity="item" :submitted="submitted"></slot>
    </div>
    <template #footer style="z-index:1012">
      <div class="p-d-flex p-jc-between">
        <div>
          <slot name="form-footer" :entity="item" :submitted="submitted"></slot>
        </div>
        <div>
          <ButtonsApplyCancel @cancel="editingOrCreating = false" @apply="onSave"
              labelOk="Запис" :blockOk="operation.loading" :saving="operation.saving"/>
        </div>
      </div>
    </template>
  </Dialog>

  <Dialog v-model:visible="operation.delete" :style="{ width: '450px' }"
    header="Потвърждение за изтриване"
    :modal="true">
    <div class="confirmation-content">
      <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 1.9rem; float: left" />
      {{messageDelete}}
    </div>
    <template #footer>
      <ButtonsApplyCancel @cancel="operation.delete = false" @apply="onDelete" labelOk="Изтрий"/>
    </template>
  </Dialog>

</template>

<script>

export default {
  emits: {
    select: null, // при избиране на елемент             // ({data})
    filter: null, // при опресняване на филтър на данните// ({query: ''})
    read  : null, // при зареждане на елеменент // TODO
    create: null, // при създаване на елеменент // TODO
    load  : null, // при зареждане на всички елементи    // ({params, onSuccess(items), onFailure(message)})
    save  : null, // при съхранение на елемент           // ({item, onSuccess(items), onFailure(message)})
    delete: null  // при изтриване на елемент            // ({item, onSuccess, onFailure(message)})
  },
  data() {
    return {
      selected: null,
      item: null,
      items: [],
      searchQuery: null,
      operation: {
        create: false,
        modify: false,
        delete: false,
        loading: false,
        saving: false
      },
      submitted: false,
      loading: false,
    };
  },

  props: {
    resource: String,
    heading: String,
    headingCreate: String,
    headingModify: String,
    headingDelete: String,
    messageDelete: String,
  },
  mounted() {
    this.refresh();
  },

  methods: {
    handleError(error) {
      if (error.response) {
        // error.response.data
        // error.response.status
        // error.response.headers
        alert(error.response.data);
      } else if(error.request) {
        alert(error.request);
      } else {
        alert(error.message);
      }
    },
    refresh() {
      this.selected = null;
      this.$emit('select', null);
      this.loadData()
    },
    loadData() {
      var ctx = this;
      this.loading = true;
      var event = {
        onSuccess: function(data) {
          ctx.items = data
          ctx.loading = false;
        },
        onFailure: function(error) {
          ctx.loading = false;
          ctx.handleError(error);
        }
      };
      var params = {
        query: this.searchQuery,
      };
      this.$emit('filter', params);
      this.$http.get(this.resource, {params: params})
        .then(res => event.onSuccess(res.data))
        .catch(res => event.onFailure(res))
    },
    onCreate() {
      // Алгоритъмът работи по следния начин:
      // 1. Визуализиране на диалога със спинър в него (празно съдържание)
      // 2. Изпращане заявка към сървъра
      // 3. При успех - визуализиране съдържанието в диалога, при грешка - показване на съобщение в същия диалог
      //        при успех/грешка да се управлява съответно състоянието на бутоните, например запис не трябва
      //          да е възможен при грешка
      this.item = {};
      this.submitted = false;
      this.operation.loading = true;
      this.operation.create = true;
      this.operation.saving = false;
      var ctx = this;
      var event = {
        onSuccess: function (item) {
          ctx.$emit('create', item);
          ctx.item = item;
          ctx.operation.loading = false;
        },
        onFailure: (message) => {
          ctx.operation.loading = false;
          ctx.showFailure("Грешка при четене от сървъра", message)
        }
      };
      this.$http.get(this.resource + '/new')
        .then(res => event.onSuccess(res.data))
        .catch(res => event.onFailure(res))
    },
    onEdit() {
      // Алгоритъмът работи по следния начин:
      // 1. Визуализиране на диалога със спинър в него (празно съдържание)
      // 2. Изпращане заявка към сървъра
      // 3. При успех - визуализиране съдържанието в диалога, при грешка - показване на съобщение в същия диалог
      //        при успех/грешка да се управлява съответно състоянието на бутоните, например запис не трябва
      //          да е възможен при грешка
      this.item = {};
      this.submitted = false;
      this.operation.loading = true;
      this.operation.modify = true;
      this.operation.saving = false;
      var ctx = this;
      var event = {
        onSuccess: function (item) {
          ctx.$emit('read', item);
          ctx.item = item;
          ctx.operation.loading = false;
        },
        onFailure: (message) => {
          ctx.operation.loading = false;
          ctx.showFailure("Грешка при четене", message)
        }
      };
      this.$http.get(this.resource + '/' + this.selected.id)
        .then(res => event.onSuccess(res.data))
        .catch(res => event.onFailure(res))
    },
    onSave() {
      var ctx = this;
      var event = {
        onSuccess () {
          ctx.editingOrCreating = false;
          ctx.operation.saving = false;
          ctx.showSuccess("Успешна обработка", "Данните бяха успешно обработени от сървъра.");
          ctx.refresh();
        },
        onFailure (message) {
          ctx.operation.saving = false;
          ctx.showFailure("Грешка при запис", message)
        }
      }
      var method = null;
      if (this.operation.create) {
        method = this.$http.post;
      } else if (this.operation.modify) {
        method = this.$http.put;
      }
      this.operation.saving = true;
      console.log("Saved entity:", this.item)
      if (method) {
        method(this.resource, this.item)
          .then(event.onSuccess)
          .catch(function(response) {
            event.onFailure(response)
        });
      } else {
        alert("Invalid operation.")
      }
    },
    showSuccess(summary, message) {
      this.$toast.add({severity: "info", summary: summary, detail: message, life: 1300});
    },
    showFailure(summary, message) {
      console.log(message)
      this.$toast.add({severity: "error", summary: summary, detail: message, life: 2300});
    },
    onDelete() {
      this.operation.delete = false;
      var ctx = this;
      var event = {
        onSuccess: function() {
          ctx.refresh();
        },
        onFailure: function(error) {
          ctx.showFailure("Грешка при изтриване", error);
        }
      };
      this.$http.delete(this.resource + '/' + this.selected.id)
          .then(event.onSuccess)
          .catch(error  => event.onFailure(error.response.data) );
    },
    onSelect(event) {
      this.$emit('select', event.data);
    }
  },
  computed: {
    editingOrCreating : {
      get: function() {
        return this.operation.create || this.operation.modify;
      },
      set: function(value) {
        console.log("Setting value: ", value)
        this.operation.create = this.operation.modify = value;
      },
    }
  }
};
</script>

<style>
</style>
